const $_default =
{
    uid()
    {
        return Math.floor(Math.random() * Number.MAX_SAFE_INTEGER );
    }
}

const $_validator =
{

}

export default
{
    props:
    {
        modelValue : { type: [ Object, Array ] },
        accept     : { type: [ String ], default: '*' },
        multiple   : { type: Boolean, default: false },
        url        : { type: [ String, Object, Function ] },
        headers    : { type: Object, default: undefined },
        uid        : { type: [ String, Number ], default: $_default.uid }
    }
}